import React from "react";
import { type IntlShape, useIntl } from "react-intl";
import { Table, TableBody, TableRow, TableCell } from "@mui/material";

export interface ResolutionItem {
	type: string;
	action: {
		entityToBeModified: string;
		entitiesToBeAssociated: string[];
	};
}

interface ResolutionSectionProps {
	readonly resolutions: ResolutionItem[];
	readonly getActionDescription: (
		type: string,
		entityToBeModified: string,
		entitiesToBeAssociated: string,
		intl: IntlShape,
	) => string;
}

export const ResolutionSection: React.FC<ResolutionSectionProps> = ({ resolutions, getActionDescription }) => {
	const intl = useIntl();
	const joinWord = intl.formatMessage({ id: "or", defaultMessage: "or" });

	return (
		<Table sx={{ borderWidth: 0, padding: 0 }}>
			<TableBody>
				{resolutions.map((resolution) => (
					<TableRow
						key={`${resolution.type}-${resolution.action.entityToBeModified}-${resolution.action.entitiesToBeAssociated.join("-")}`}
					>
						<TableCell sx={{ borderWidth: 0, padding: 0 }}>
							{getActionDescription(
								resolution.type,
								resolution.action.entityToBeModified,
								resolution.action.entitiesToBeAssociated.join(` ${joinWord} `),
								intl,
							)}
						</TableCell>
					</TableRow>
				))}
			</TableBody>
		</Table>
	);
};
